module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-epigraph element-without-heading",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('div', {
    staticClass: "blockquote-container prose with-attribution"
  }, [_c('blockquote', {
    staticClass: "prose with-attribution"
  }, [_c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first"
  }, [_vm._v("“I’ll come to thee by moonlight,")]), _vm._v(" "), _c('div', {
    staticClass: "paragraph-and-attribution"
  }, [_c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose"
  }, [_vm._v("though hell should bar the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-attribution blockquote-position-last"
  }, [_c('i', [_vm._v("The Highwayman ")]), _vm._v("Alfred Noyes (1880-1958)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a0d7e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 66
// module chunks = 0